import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Index",
    meta: {
      title: "首页",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "首页",
    },
    component: () => import("../pages/index/index.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录",
      keepAlive: true,
      requireAuth: true,
      pageTitle: "H5一键登录",
    },
    component: () => import("../pages/login/index.vue"),
  },
  {
    path: "/phone",
    name: "Phone",
    meta: {
      title: "注册登录",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "注册登录",
    },
    component: () => import("../pages/login/phone.vue"),
  },
  {
    path: "/code",
    name: "Code",
    meta: {
      title: "短信验证",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "短信验证",
    },
    component: () => import("../pages/login/code.vue"),
  },
  {
    path: "/codea",
    name: "Codea",
    meta: {
      title: "短信验证",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "短信验证",
    },
    component: () => import("../pages/login/codea.vue"),
  },
  {
    path: "/ocrIndex",
    name: "OcrIndex",
    meta: {
      title: "身份证照",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "身份证照",
    },
    component: () => import("../pages/ocr/index.vue"),
  },
  {
    path: "/authentication",
    name: "Authentication",
    meta: {
      title: "实名认证",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "实名认证",
    },
    component: () => import("../pages/ocr/authentication.vue"),
  },
  {
    path: "/creditList",
    name: "CreditList",
    meta: {
      title: "激活额度",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "授信列表",
    },
    component: () => import("../pages/creditList/index.vue"),
  },
  {
    path: "/creditPage",
    name: "CreditPage",
    meta: {
      title: "协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "协议",
    },
    component: () => import("../pages/creditPage/index.vue"),
  },
  {
    path: "/info",
    name: "Info",
    meta: {
      title: "基本信息",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "基本信息",
    },
    component: () => import("../pages/info/info.vue"),
  },
  {
    path: "/face",
    name: "Face",
    meta: {
      title: "人脸识别",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "人脸识别",
    },
    component: () => import("../pages/ocr/face.vue"),
  },
  {
    path: "/loanIndex",
    name: "LoanIndex",
    meta: {
      title: "借款确认",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "借款确认",
    },
    component: () => import("../pages/loan/index.vue"),
  },
  {
    path: "/loanBenefit",
    name: "LoanBenefit",
    meta: {
      title: "借款确认",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "借款确认",
    },
    component: () => import("../pages/loan/benefit.vue"),
  },
  {
    path: "/loanAgreement",
    name: "LoanAgreement",
    meta: {
      title: "借款协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "借款协议",
    },
    component: () => import("../pages/loan/agreement.vue"),
  },
  {
    path: "/contractsList",
    name: "ContractsList",
    meta: {
      title: "借款协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "借款协议",
    },
    component: () => import("../pages/loan/contractsList.vue"),
  },
  {
    path: "/ocrLoading",
    name: "OcrLoading",
    meta: {
      title: "臻甜瓜分期",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "loading",
    },
    component: () => import("../pages/ocr/loading.vue"),
  },
  {
    path: "/hkResult",
    name: "HkResult",
    meta: {
      title: "还款结果",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "还款结果",
    },
    component: () => import("../pages/result/hkIndex.vue"),
  },
  {
    path: "/jkResult",
    name: "JkResult",
    meta: {
      title: "借款结果",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "借款结果",
    },
    component: () => import("../pages/result/jkIndex.vue"),
  },
  {
    path: "/sxResult",
    name: "SxResult",
    meta: {
      // 授信审核结果
      title: "审核结果",
      keepAlive: false,
      requireAuth: true,
      multipleTitles: true,
      pageTitleH5: "授信审核中转下载",
      pageTitleApp: "审核结果",
    },
    component: () => import("../pages/result/sxIndex.vue"),
  },
  {
    path: "/download",
    name: "DownLoad",
    meta: {
      title: "臻甜瓜分期",
      keepAlive: true,
      requireAuth: true,
      pageTitle: "注册落地⻚",
    },
    component: () => import("../pages/download/index.vue"),
  },
  {
    path: "/downloadB01B",
    name: "DownloadB01B",
    meta: {
      title: "臻甜瓜分期",
      keepAlive: true,
      requireAuth: true,
      pageTitle: "注册落地⻚B01B",
    },
    component: () => import("../pages/download/downloadB01B.vue"),
  },
  {
    path: "/downloadB02B",
    name: "DownloadB02B",
    meta: {
      title: "臻甜瓜分期",
      keepAlive: true,
      requireAuth: true,
      pageTitle: "注册落地⻚B02B",
    },
    component: () => import("../pages/download/downloadB02B.vue"),
  },
  {
    path: "/downloadA",
    name: "DownloadA",
    meta: {
      title: "借款申请",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "下载A-豆豆钱",
    },
    component: () => import("../pages/download/downloadA.vue"),
  },
  {
    path: "/downloadC",
    name: "DownloadC",
    meta: {
      title: "借款申请",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "下载C-豆豆钱",
    },
    component: () => import("../pages/download/downloadC.vue"),
  },
  {
    path: "/downloadB",
    name: "DownloadB",
    meta: {
      title: "借款申请",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "下载B-豆豆钱",
    },
    component: () => import("../pages/download/downloadB.vue"),
  },
  {
    path: "/downloadD",
    name: "DownloadD",
    meta: {
      title: "借款申请",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "下载D-豆豆钱",
    },
    component: () => import("../pages/download/downloadD.vue"),
  },
  {
    path: "/downloadF",
    name: "DownloadF",
    meta: {
      title: "借款申请",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "下载F-豆豆钱",
    },
    component: () => import("../pages/download/downloadF.vue"),
  },
  /* {
    path: "/uploadApk",
    name: "UploadApk",
    meta: {
      title: "",
      keepAlive: false,
      requireAuth: true,
    },
    component: () => import("../pages/download/uploadApk.vue"),
  }, */
  {
    path: "/pscIndex",
    name: "PscIndex",
    meta: {
      title: "我的",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "我的",
    },
    component: () => import("../pages/psc/index.vue"),
  },
  {
    path: "/pscAbout",
    name: "PscAbout",
    meta: {
      title: "关于我们",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "关于我们",
    },
    component: () => import("../pages/psc/about.vue"),
  },
  {
    path: "/agreement",
    name: "Agreement",
    meta: {
      title: "用户协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "用户协议",
    },
    component: () => import("../pages/psc/agreement.vue"),
  },
  {
    path: "/digitalCertificate",
    name: "AigitalCertificate",
    meta: {
      title: "数字证书使用协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "数字证书使用协议",
    },
    component: () => import("../pages/psc/digitalCertificate.vue"),
  },
  {
    path: "/agreementAuth",
    name: "AgreementAuth",
    meta: {
      title: "个人信息查询及使用授权书",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "个人信息查询及使用授权书",
    },
    component: () => import("../pages/psc/agreementAuthorization.vue"),
  },
  {
    path: "/rpagreem",
    name: "Rpagreem",
    meta: {
      title: "借款协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "借款协议",
    },
    component: () => import("../pages/rp/agreem.vue"),
  },
  {
    path: "/agreementNew",
    name: "AgreementNew",
    meta: {
      title: "注册协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "注册协议",
    },
    component: () => import("../pages/psc/agreementNew.vue"),
  },
  {
    path: "/xiaohuaAgreement",
    name: "XiaohuaAgreement",
    meta: {
      title: "授信协议",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "授信协议",
    },
    component: () => import("../pages/psc/xiaohuaAgreement.vue"),
  },
  {
    path: "/agreementOld",
    name: "AgreementOld",
    meta: {
      title: "隐私政策",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "隐私政策",
    },
    component: () => import("../pages/psc/agreementOld.vue"),
  },
  {
    path: "/agreementUser",
    name: "AgreementUser",
    meta: {
      title: "一键登录用户协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "一键登录用户协议",
    },
    component: () => import("../pages/psc/agreementUser.vue"),
  },
  {
    path: "/pscSetting",
    name: "PscSetting",
    meta: {
      title: "设置",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "设置",
    },
    component: () => import("../pages/psc/setting.vue"),
  },
  {
    path: "/account",
    name: "Account",
    meta: {
      title: "账号管理",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "账号管理",
    },
    component: () => import("../pages/psc/account.vue"),
  },
  {
    path: "/logOffOne",
    name: "LogOffOne",
    meta: {
      title: "注销申请",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "注销申请",
    },
    component: () => import("../pages/psc/logOff/one.vue"),
  },
  {
    path: "/logOffTwo",
    name: "LogOffTwo",
    meta: {
      title: "注销原因",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "注销原因",
    },
    component: () => import("../pages/psc/logOff/two.vue"),
  },
  {
    path: "/logOffThree",
    name: "LogOffThree",
    meta: {
      title: "注销验证",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "注销验证",
    },
    component: () => import("../pages/psc/logOff/three.vue"),
  },
  {
    path: "/logOffOk",
    name: "LogOffOk",
    meta: {
      title: "注销申请完成",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "注销申请完成",
    },
    component: () => import("../pages/psc/logOff/ok.vue"),
  },
  {
    path: "/personInfoList",
    name: "PersonInfoList",
    meta: {
      title: "个人信息收集清单",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "个人信息收集清单",
    },
    component: () => import("../pages/psc/personInfoList.vue"),
  },
  {
    path: "/otherInfoShareList",
    name: "OtherInfoShareList",
    meta: {
      title: "第三方信息共享清单",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "第三方信息共享清单",
    },
    component: () => import("../pages/psc/otherInfoShareList.vue"),
  },
  {
    path: "/myInfoManager",
    name: "MyInfoManager",
    meta: {
      title: "个人信息管理",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "个人信息管理",
    },
    component: () => import("../pages/psc/myInfoManager.vue"),
  },
  {
    path: "/billIndex",
    name: "BillIndex",
    meta: {
      title: "账单",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "借款账单",
    },
    component: () => import("../pages/bill/index.vue"),
  },
  {
    path: "/billDetail",
    name: "BillDetail",
    meta: {
      title: "账单详情",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "账单详情",
    },
    component: () => import("../pages/bill/detail.vue"),
  },
  {
    path: "/billDetailBenefit",
    name: "BillDetailBenefit",
    meta: {
      title: "账单详情",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "账单详情",
    },
    component: () => import("../pages/bill/detailBenefit.vue"),
  },
  {
    path: "/infoCode",
    name: "InfoCode",
    meta: {
      title: "个人信息管理",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "个人信息管理",
    },
    component: () => import("../pages/psc/infoCode.vue"),
  },
  {
    path: "/xygjIndex",
    name: "XygjIndex",
    meta: {
      title: "风险洞察",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "风险检测",
    },
    component: () => import("../pages/xygj/index.vue"),
  },
  {
    path: "/billSub",
    name: "billSub",
    meta: {
      title: "确认还款",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "确认还款",
    },
    component: () => import("../pages/bill/billSub.vue"),
  },
  {
    path: "/billSubBenefit",
    name: "billSubBenefit",
    meta: {
      title: "确认还款",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "确认还款",
    },
    component: () => import("../pages/bill/billSubBenefit.vue"),
  },
  {
    path: "/downLoadOpen",
    name: "DownLoadOpen",
    meta: {
      title: "甜瓜借钱-最高可借20万元",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "甜瓜借钱-最高可借20万元",
    },
    component: () => import("../pages/download/open.vue"),
  },
  {
    path: "/customer",
    name: "Customer",
    meta: {
      title: "客服",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "客服",
    },
    component: () => import("../pages/customer/index.vue"),
  },
  {
    // 甜瓜好用注册协议(融担 iOS)
    path: "/agreementRegisterIOS",
    name: "AgreementRegisterIOS",
    meta: {
      title: "注册协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "iOS注册协议",
    },
    component: () => import("../pages/psc/agreements/agreementRegisterIOS.vue"),
  },
  {
    // 甜瓜好用隐私政策(融担 iOS)
    path: "/agreementPrivacyPolicyIOS",
    name: "AgreementPrivacyPolicyIOS",
    meta: {
      title: "隐私政策",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "iOS隐私政策",
    },
    component: () => import("../pages/psc/agreements/agreementPrivacyPolicyIOS.vue"),
  },
  {
    // 甜瓜随手记隐私政策(融担 iOS 记事本工具（未上架）)
    path: "/ztgPrivacyPolicyIOS",
    name: "ztgPrivacyPolicyIOS",
    meta: {
      title: "隐私政策",
      keepAlive: false,
      requireAuth: true,
    },
    component: () => import("../pages/psc/ztgPrivacyPolicyIOS.vue"),
  },
  {
    /// 臻甜瓜隐私政策（华翊 iOS）
    path: "/iOSHyPrivacyPolicy",
    name: "iOSHyPrivacyPolicy",
    meta: {
      title: "隐私政策",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "iOS隐私政策",
    },
    component: () => import("../pages/psc/iOSHyPrivacyPolicy.vue"),
  },
  {
    /// 臻甜瓜注册协议（华翊 iOS）
    path: "/iOSHyRegister",
    name: "iOSHyRegister",
    meta: {
      title: "臻甜瓜注册协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "臻甜瓜注册协议",
    },
    component: () => import("../pages/psc/iOSHyRegister.vue"),
  },
  {
    /// 臻甜瓜一键登录用户协议（华翊 iOS）
    path: "/iOSHyUser",
    name: "iOSHyUser",
    meta: {
      title: "一键登录用户协议",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "一键登录用户协议",
    },
    component: () => import("../pages/psc/iOSHyUser.vue"),
  },
  {
    path: "/shop",
    name: "Shop",
    meta: {
      title: "",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "",
    },
    component: () => import("../pages/psc/shop.vue"),
  },
  // 关注微信
  {
    path: "/flowWeChat",
    name: "FlowWeChat",
    meta: {
      title: "臻甜瓜分期-绑定微信最高得20万",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "臻甜瓜分期-绑定微信最高得20万",
    },
    component: () => import("../pages/flowWeChat/index.vue"),
  },
  // 商城返回中间页
  {
    path: "/toHomePage",
    name: "ToHomePage",
    meta: {
      title: "",
      keepAlive: false,
      requireAuth: true,
      pageTitle: "",
    },
    component: () => import("../pages/psc/toHomePage.vue"),
  },
  // 常见疑问 faq
  {
    path: "/faq",
    name: "Faq",
    meta: {
      title: "常见疑问",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "常见疑问",
    },
    component: () => import("../pages/faq/index.vue"),
  },
  // 借款指南 loanGuide
  {
    path: "/loanGuide",
    name: "LoanGuide",
    meta: {
      title: "借款指南",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "借款指南",
    },
    component: () => import("../pages/loanGuide/index.vue"),
  },
  // 地图插件
  {
    path: "/map",
    name: "Map",
    meta: {
      title: "标记位置",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "标记位置",
    },
    component: () => import("../pages/map/index.vue"),
  },
  // 苹果 甜瓜好用app 首页 已登录的
  {
    path: "/aideHomePage",
    name: "AideHomePage",
    meta: {
      title: "甜瓜好用",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "甜瓜好用",
    },
    // component: () => import("../pages/iosAide/index.vue"),
    component: () => import("../pages/index/index.vue"),
  },
  // 苹果 甜瓜好用app 首页 未登录的
  {
    path: "/aideHomePageNoLogin",
    name: "AideHomePageNoLogin",
    meta: {
      title: "甜瓜好用",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "甜瓜好用",
    },
    component: () => import("../pages/index/index.vue"),
    // component: () => import("../pages/iosAide/indexNoLogin.vue"),
  },
  // 苹果 app 行业资讯
  {
    path: "/iosNews",
    name: "IosNews",
    meta: {
      title: "行业资讯",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "行业资讯",
    },
    component: () => import("../pages/iosAide/news.vue"),
  },
  // 苹果 app 行业资讯详情
  {
    path: "/iosNewsDetail",
    name: "IosNewsDetail",
    meta: {
      title: "行业资讯详情",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "行业资讯详情",
    },
    component: () => import("../pages/iosAide/newsDetail.vue"),
  },
  // 协议集合页面
  {
    path: "/policy",
    name: "Policy",
    meta: {
      title: "协议",
      keepAlive: false,
      requireAuth: false,
      pageTitle: "协议",
    },
    component: () => import("../pages/policy/index.vue"),
  },
  {
    path: "/policyMaterials",
    name: "PolicyMaterials",
    meta: {
      title: "个人信息共享及征信授权协议",
      pageTitle: "个人信息共享及征信授权协议",
      keepAlive: false,
      requireAuth: false,
    },
    component: () => import("../pages/policy/materials.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

let prevPageTitle: any = "";

import { isApp, isIos } from "@/utils/bridge";
import { currentTheme } from "@/theme";

// 路由守卫
router.beforeEach((to, from, next) => {
  // 缓存前一个页面的 title
  if (from.meta.multipleTitles) {
    if (isApp() || isIos()) {
      prevPageTitle = from.meta.pageTitleApp || "";
    } else {
      prevPageTitle = from.meta.pageTitleH5 || "";
    }
  } else {
    prevPageTitle = from.meta.pageTitle || "";
  }
  /* 路由发生变化默认 当前页面title */
  if (to.meta.title) {
    let title = to.meta.title || "臻甜瓜分期";
    if (currentTheme.value === "tg_blue") {
      title = title.replace(/臻甜瓜分期/g, "臻甜瓜");
    }
    document.title = title;
  }
  next();
});

// 导出一个获取前一个页面 title 的方法
export function getPrevPageTitle() {
  return prevPageTitle;
}

export default router;
